import { inject } from '@angular/core';
import { HttpInterceptorFn } from '@angular/common/http';
import { MtmAuthBridgeService } from '@mtm/auth-ui-angular';
import { environment } from '@environments/environment';

export const appTokenInterceptor: HttpInterceptorFn = (req, next) => {
  if (!req.url.startsWith(environment.appApiUrl)) {
    return next(req);
  }

  const token = inject(MtmAuthBridgeService).getAppTokenSync();

  if (!token) return next(req);

  return next(req.clone({ setHeaders: { Authorization: `Bearer ${token}` } }));
};
